<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    app
    dark
    floating
    color="#0f172a"
    width="256"
    mini-variant-width="76"
    :mini-variant="miniVariant"
    :mobile-breakpoint="1024"
  >
    <div class="pulse-sidebar">
      <div class="pulse-sidebar__brand" @click="$router.push('/inicio')">
        <img :src="icon" alt="Pulse" class="pulse-sidebar__logo" />
        <span v-if="!miniVariant" class="pulse-sidebar__name">Operação</span>
      </div>

      <router-link
        to="/inicio"
        class="pulse-sidebar__link pulse-sidebar__home"
        :class="{ 'pulse-sidebar__link--active': $route.path === '/inicio' }"
        :title="miniVariant ? 'Bem-vindo ao Pulse' : null"
      >
        <i class="pi pi-th-large pulse-sidebar__icon" />
        <span v-if="!miniVariant" class="pulse-sidebar__label">Bem-vindo ao Pulse</span>
      </router-link>

      <div class="pulse-sidebar__separator" />

      <nav class="pulse-sidebar__nav thin-scrollbar">
        <div v-for="secao in secoes" :key="secao.label" class="pulse-sidebar__section">
          <p v-if="!miniVariant" class="pulse-sidebar__section-label">{{ secao.label }}</p>
          <router-link
            v-for="item in secao.items"
            :key="item.to"
            :to="item.to"
            class="pulse-sidebar__link"
            :class="{ 'pulse-sidebar__link--active': isActive(item) }"
            :title="miniVariant ? item.title : null"
          >
            <i :class="[item.icon, 'pulse-sidebar__icon']" />
            <span v-if="!miniVariant" class="pulse-sidebar__label">{{ item.title }}</span>
            <span v-if="!miniVariant && item.isBeta" class="pulse-sidebar__beta">BETA</span>
          </router-link>
        </div>
      </nav>

      <button
        v-if="!isMobile"
        type="button"
        class="pulse-sidebar__collapse"
        @click="alternarColapso"
      >
        <i :class="miniVariant ? 'pi pi-angle-double-right' : 'pi pi-angle-double-left'" />
        <span v-if="!miniVariant">Recolher</span>
      </button>
    </div>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapState } from "vuex";
import { drawerItems } from "@/config/navigationConfig";
import icon from "@/assets/pulse_v1_icon.png";

const COLLAPSED_KEY = "pulse.operacao.sidebarCollapsed";

export default {
  name: "DashboardCoreDrawer",

  props: {
    expandOnHover: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    icon,
    collapsed: localStorage.getItem(COLLAPSED_KEY) === "1",
    promotores: [],
    user: "",

    items: drawerItems,
    /* REMOVIDO - Agora usando drawerItems de navigationConfig.js
    items: [
      {
        title: "Performance",
        roles: [
          "ROLE_RESUMO",
          "ROLE_CAMPANHA",
          "ROLE_CONTRATO",
          "ROLE_OBITO",
          "ROLE_SEPULTAMENTO",
          "ROLE_INADIMPLENCIA_PERFORMANCE",
          "ROLE_ACORDO_PERFORMANCE",
          "ROLE_SINISTRALIDADE",
          "ROLE_CONTAS",
        ],
      },

      {
        icon: "mdi-calculator",
        title: "Resumo",
        roles: ["ROLE_RESUMO"],
        to: "financeiro",
      },

      {
        icon: "mdi-file-document-check-outline",
        title: "Carteira",
        roles: ["ROLE_CONTRATO"],
        to: "contrato",
      },

      {
        icon: "mdi-coffin",
        title: "?bitos",
        roles: ["ROLE_OBITO"],
        to: "obito",
      },

      {
        icon: "mdi-flower",
        title: "Sepultamento",
        roles: ["ROLE_SEPULTAMENTO"],
        to: "sepultamento",
      },

      {
        icon: "mdi-cash-clock",
        title: "Inadimpl?ncia",
        roles: ["ROLE_INADIMPLENCIA_PERFORMANCE"],
        to: "inadimplenciaPerformance",
      },

      {
        icon: "mdi-handshake",
        title: "Acordos",
        roles: ["ROLE_ACORDO_PERFORMANCE"],
        to: "acordosPerformance",
      },

      {
        icon: "mdi-alert",
        title: "Sinistralidade",
        roles: ["ROLE_SINISTRALIDADE"],
        to: "sinistralidade",
      },

      {
        icon: "mdi-calculator",
        title: "Contas",
        roles: ["ROLE_CONTAS"],
        to: "contas",
      },

      {
        title: "",
      },

      {
        title: "Acompanhamento",
        roles: [
          "ROLE_AUDITORIA",
          "ROLE_COBRANCA",
          "ROLE_FATURAMENTO",
          "ROLE_ACOMPANHAMENTO_VENDA",
          "ROLE_REMESSA_NEGATIVADO",
          "ROLE_NEGATIVADO",
          "ROLE_COB_FUNERARIA",
          "ROLE_COB_RELACIONAMENTO",
          "ROLE_COB_SEPULTAMENTO",
          "ROLE_FUNERARIA",
          "ROLE_LOJA",
          "ROLE_RETENCAO",
          "ROLE_IMPORTACAO_CONSULTA",
          "ROLE_IMPORTACAO_DOWNLOAD",
          "ROLE_IMPORTACAO_FILE_STATUS",
          "ROLE_IMPORTACAO_FILE",
          "ROLE_GESTAO_CARTEIRA",
          "ROLE_FALECIDOS",
        ],
      },

      {
        icon: "mdi-marker",
        title: "Auditoria",
        roles: ["ROLE_AUDITORIA"],
        to: "auditoria",
      },

      {
        icon: "mdi-cash-refund",
        title: "Cobran?a",
        roles: ["ROLE_REMESSA_NEGATIVADO", "ROLE_COBRANCA", "ROLE_NEGATIVADO"],
        to: "cobranca",
        group: "",
        children: [
          {
            icon: "mdi-cash-refund",
            title: "Acordos",
            // roles: [ 'ROLE_COBRANCA'],
            to: "cobranca",
          },

          {
            title: "Negativados",
            //  roles: [ 'ROLE_NEGATIVADO'],
            to: "negativados",
          },

          {
            title: "Remessa Serasa",
            // roles: [ 'ROLE_REMESSA_NEGATIVADO'],
            to: "remessa",
          },
        ],
      },

      {
        icon: "mdi-finance",
        title: "Faturamento",
        roles: ["ROLE_FATURAMENTO"],
        to: "faturamento",
      },

      {
        icon: "mdi-toolbox-outline",
        title: "Servi?os Funer?rios",
        roles: ["ROLE_COB_FUNERARIA"],
        to: "",
      },

      {
        icon: "mdi-face-agent",
        title: "Relacionamento",
        roles: ["ROLE_COB_RELACIONAMENTO"],
        to: "",
      },

      {
        icon: "mdi-grave-stone",
        title: "Sepultamento",
        roles: ["ROLE_COB_SEPULTAMENTO"],
        to: "",
      },

      {
        icon: "mdi-sale",
        title: "Vendas",
        roles: ["ROLE_ACOMPANHAMENTO_VENDA"],
        to: "acompanhamentovenda",
      },

      {
        icon: "mdi-toolbox-outline",
        title: "Funer?ria",
        roles: ["ROLE_FUNERARIA"],
        to: "funeraria",
      },

      {
        icon: "mdi-store",
        title: "Loja",
        roles: ["ROLE_LOJA"],
        to: "loja",
      },

      {
        icon: "mdi-safe",
        title: "Reten??o de Vendas",
        roles: ["ROLE_RETENCAO"],
        to: "retencao",
      },
      {
        icon: "mdi-file-arrow-up-down-outline",
        title: "Arquivos",
        roles: [
          "ROLE_IMPORTACAO_CONSULTA",
          "ROLE_IMPORTACAO_DOWNLOAD",
          "ROLE_IMPORTACAO_FILE_STATUS",
          "ROLE_IMPORTACAO_FILE",
        ],
        to: "gestaoArquivos",
      },
      {
        icon: "mdi-wallet-outline",
        title: "Gest?o de Carteira",
        roles: ["ROLE_GESTAO_CARTEIRA"],
        to: "gestaoCarteira",
      },

      {
        icon: "mdi-grave-stone",
        title: "Falecidos",
        roles: ["ROLE_FALECIDOS"],
        to: "falecidos",
      },
      {
        title: "",
      },

      {
        title: "SAC",
        roles: [
          "ROLE_CHAT",
          "ROLE_CHAT_CONSULTA",
          "ROLE_ADMIN",
          "ROLE_ETIQUETA_CONSULTA",
          "ROLE_ETIQUETA_CADASTRO",
        ],
      },

      {
        icon: "mdi-chat",
        title: "Chat",
        roles: ["ROLE_CHAT"],
        to: "chat",
      },
      {
        icon: "mdi-chat",
        title: "Chat Receptivo",
        roles: ["ROLE_CHAT_RECEPTIVO"],
        to: "chat-wazzup",
      },
      {
        icon: "mdi-magnify",
        title: "Consulta",
        roles: ["ROLE_CHAT_CONSULTA"],
        to: "consulta-chat",
      },
      {
        icon: "mdi-format-list-bulleted",
        title: "Filas",
        roles: ["ROLE_CHAT_FILAS"],
        to: "filas",
      },
      {
        icon: "mdi-message-text-outline",
        title: "Templates",
        roles: ["ROLE_TEMPLATES"],
        to: "templates",
      },
      {
        icon: "mdi-tune",
        title: "Parâmetros",
        roles: [
          "ROLE_ADMIN",
          "ROLE_PARAMETROS",
          "ROLE_PARAMETROS_CONSULTA",
          "ROLE_PARAMETROS_CADASTRO",
          "ROLE_TEMPLATES",
        ],
        to: "parametros",
      },
      {
        icon: "mdi-robot",
        title: "URAs",
        roles: ["ROLE_URAS"],
        to: "uras",
      },
      {
        icon: "mdi-tag-multiple",
        title: "Etiquetas",
        roles: ["ROLE_ADMIN", "ROLE_ETIQUETA_CONSULTA", "ROLE_ETIQUETA_CADASTRO"],
        to: "etiquetas",
      },

      {
        title: "",
      },

      {
        title: "Central de Consultas",
        roles: ["ROLE_ADMIN", "ROLE_LEMIT_CONSULTA", "ROLE_LEMIT_SALDO", "ROLE_USER"],
      },

      {
        icon: "mdi-magnify-scan",
        title: "An?lise",
        roles: ["ROLE_ADMIN", "ROLE_LEMIT_CONSULTA"],
        to: "central-consultas-analise",
      },

      {
        icon: "mdi-cash-check",
        title: "Saldo",
        roles: ["ROLE_ADMIN", "ROLE_LEMIT_SALDO"],
        to: "central-consultas-saldo",
      },

      {
        icon: "mdi-chart-box-outline",
        title: "LTV",
        roles: ["ROLE_ADMIN", "ROLE_USER"],
        to: "consulta-ltv",
      },

      {
        title: "",
      },




      {
        title: "Comunica??o",
        roles: ["ROLE_BATEPAPO"],
      },
      {
        icon: "mdi-comment-account-outline",
        title: "Batepapo",
        roles: ["ROLE_BATEPAPO"],
        to: "batepapo",
      },

      {
        title: "",
      },

      {
        title: "Comiss?o",
        roles: [
          "ROLE_COMISSAO",
          "ROLE_COMISSAO_VENDA",
          "ROLE_COMISSAO_FUNERARIA",
          "ROLE_COMISSAO_ENTREGAS",
          "ROLE_COMISSAO_CONTROLE",
          "ROLE_VENDAS_RADAR",
        ],
      },

      {
        icon: "mdi-percent",
        title: "Acordos",
        roles: ["ROLE_COMISSAO"],
        to: "comissao",
      },

      {
        icon: "mdi-percent",
        title: "Vendas",
        roles: ["ROLE_COMISSAO_VENDA"],
        to: "comissaoVenda",
      },

      {
        icon: "mdi-percent",
        title: "Funer?ria",
        roles: ["ROLE_COMISSAO_FUNERARIA"],
        to: "comissaoFuneraria",
      },

      {
        icon: "mdi-percent",
        title: "Entregas",
        roles: ["ROLE_COMISSAO_ENTREGAS"],
        to: "comissaoEntrega",
      },

      {
        icon: "mdi-link-variant",
        title: "V?nculo",
        roles: ["ROLE_COMISSAO_CONTROLE"],
        to: "comissaoControle",
      },

      {
        icon: "mdi-alert-octagon",
        title: "Ocorr?ncia",
        roles: ["ROLE_COMISSAO_CONTROLE"],
        to: "comissaoConformidade",
      },

      {
        icon: "mdi-sale",
        title: "Vendas Radar",
        roles: ["ROLE_VENDAS_RADAR"],
        to: "vendasRadar",
      },

      {
        title: "",
      },

      {
        title: "Colaboradores",
        roles: ["ROLE_COMISSAO_ALELO", "ROLE_GRUPOS_COLABORADORES"],
      },

      {
        icon: "mdi-gift",
        title: "Comiss?es Alelo",
        roles: ["ROLE_COMISSAO_ALELO"],
        to: "comissaoAlelo",
      },
      {
        icon: "mdi-account-multiple",
        title: "Grupos de Colaboradores",
        roles: ["ROLE_GRUPOS_COLABORADORES"],
        to: "gruposColaboradores",
      },

      {
        title: "",
      },

      {
        title: "Bitrix",
        roles: ["ROLE_BITRIX"],
      },

      {
        icon: "mdi-account-multiple",
        title: "Leads",
        roles: ["ROLE_BITRIX"],
        to: "bitrixLead",
      },

      {
        title: "",
      },

      {
        title: "Consulta Gen?rica",
        roles: [
          "ROLE_RECEITA",
          "ROLE_INADIMPLENCIA",
          "ROLE_VENDA",
          "ROLE_CANCELAMENTO",
          "ROLE_RENEGOCIACAO",
          "ROLE_VENDAS_EMPRESA",
          "ROLE_MANUTENCAO_DOC",
        ],
      },

      {
        icon: "mdi-cash",
        title: "Receita",
        roles: ["ROLE_RECEITA"],
        to: "receita",
      },
      {
        icon: "mdi-filter-variant",
        title: "Consulta Dinamica",
        roles: ["ROLE_RECEITA"],
        to: "consultaDinamica",
      },

      {
        icon: "mdi-cash-clock",
        title: "Inadimpl?ncia",
        roles: ["ROLE_INADIMPLENCIA"],
        to: "inadimplencia",
      },

      {
        icon: "mdi-sale",
        title: "Vendas",
        roles: ["ROLE_VENDA"],
        to: "venda",
      },

      {
        icon: "mdi-sale",
        title: "Entre Empresas",
        roles: ["ROLE_VENDAS_EMPRESA"],
        to: "vendasEmpresas",
      },

      {
        icon: "mdi-delete",
        title: "Cancelamentos",
        roles: ["ROLE_CANCELAMENTO"],
        to: "cancelamento",
      },

      {
        icon: "mdi-handshake",
        title: "Renegocia??o",
        roles: ["ROLE_RENEGOCIACAO"],
        to: "acordos",
      },

      {
        icon: "mdi-text-box-search-outline",
        title: "Documentos",
        roles: ["ROLE_MANUTENCAO_DOC"],
        to: "documentos",
      },

      {
        title: "",
      },

      {
        title: "Stratws",
        roles: ["ROLE_STRATUS"],
      },
      {
        icon: "mdi-finance",
        title: "Indicadores",
        roles: ["ROLE_STRATUS"],
        to: "indicadores",
      },
      {
        icon: "mdi-cloud-upload",
        title: "Importa??o Stratws",
        roles: ["ROLE_STRATUS"],
        to: "importacao-stratws",
      },

      {
        title: "",
      },

      {
        title: "Invita",
        roles: ["ROLE_DS"],
      },
      {
        icon: "mdi-file",
        title: "Arquivos DS",
        roles: ["ROLE_DS"],
        to: "invita",
      },
      {
        title: "",
      },
      {
        title: "GLPI",
        roles: ["ROLE_GLPI"],
      },
      {
        icon: "mdi-clipboard-text-search-outline",
        title: "Consulta GLPI",
        roles: ["ROLE_GLPI"],
        to: "consulta-glpi",
      },
      {
        icon: "mdi-account-group",
        title: "Acompanhamento por Setor",
        roles: ["ROLE_GLPI"],
        to: "acompanhamento-glpi",
      },

      {
        title: "",
      },
      {
        title: "Mensageria",
        roles: ["ROLE_MENSAGERIA_CLIENTE", "ROLE_MENSAGERIA_COLABORADOR", "ROLE_MENSAGERIA_LOTE", "ROLE_MENSAGERIA_ANIVERSARIO", "ROLE_MENSAGERIA_CONSULTA"],
      },
      {
        icon: "mdi-account-arrow-right",
        title: "Disparos Clientes",
        roles: ["ROLE_MENSAGERIA_CLIENTE"],
        to: "mensageria-externa",
      },
      {
        icon: "mdi-receipt-text-send",
        title: "Disparos Colaboradores",
        roles: ["ROLE_MENSAGERIA_COLABORADOR"],
        to: "mensageria-interna",
      },
      {
        icon: "mdi-email-multiple",
        title: "Disparo em Lote",
        roles: ["ROLE_MENSAGERIA_LOTE"],
        to: "mensageria-lote",
      },
      {
        icon: "mdi-cake",
        title: "Disparo Anivers?rio",
        roles: ["ROLE_MENSAGERIA_ANIVERSARIO"],
        to: "mensageria-aniversario",
      },
      {
        icon: "mdi-magnify",
        title: "Consulta",
        roles: ["ROLE_MENSAGERIA_CONSULTA"],
        to: "mensageria-consulta",
      },
      {
        title: "",
      },
      {
        title: "Fluxo de Servi?os",
        roles: ["ROLE_SERVICO_FUNERARIO", "ROLE_SERVICO_FUNERARIO_EDICAO", "ROLE_FLUXO_DEVOLVIDO"],
      },
      {
        icon: "mdi-coffin",
        title: "Funer?ria",
        roles: ["ROLE_SERVICO_FUNERARIO", "ROLE_SERVICO_FUNERARIO_EDICAO"],
        to: "fluxo-servico-funerario",
      },
      {
        icon: "mdi-file-rotate-left",
        title: "Faturamento",
        roles: ["ROLE_FLUXO_DEVOLVIDO"],
        to: "fluxo-carne-devolvidos",
      },

      {
        title: "",
      },

      {
        title: "Relatórios",
        roles: [
          "ROLE_SERVICO_FUNERARIO",
          "ROLE_SERVICO_FUNERARIO_EDICAO",
          "ROLE_SERVICO_FUNERARIO_RELATORIO",
          "ROLE_SERVICO_FUNERARIO_RELATORIO_AGENTE",
          "ROLE_ADMIN",
        ],
      },

      {
        icon: "mdi-clipboard-pulse-outline",
        title: "Funerário",
        roles: [
          "ROLE_SERVICO_FUNERARIO",
          "ROLE_SERVICO_FUNERARIO_EDICAO",
          "ROLE_SERVICO_FUNERARIO_RELATORIO",
          "ROLE_SERVICO_FUNERARIO_RELATORIO_AGENTE",
          "ROLE_ADMIN",
        ],
        to: "relatorio-funerario",
      },

      {
        title: "",
      },

      {
        title: "Financeiro",
        roles: [
          "ROLE_IMPORTACAO_RADAR",
          "ROLE_IMPORTACAO_RADAR_APP",
          "ROLE_FLUXO",
          "ROLE_CONCILIACAO",
          "ROLE_DOCUEMNTOS_IVERTEX",
        ],
      },

      {
        icon: "mdi-finance",
        title: "Fluxo",
        roles: ["ROLE_FLUXO"],
        to: "fluxo",
      },

      {
        icon: "mdi-cash-clock",
        title: "Radar Documentos",
        roles: ["ROLE_IMPORTACAO_RADAR"],
        to: "importacao",
      },

      {
        icon: "mdi-cash-clock",
        title: "Importa??o Radar",
        roles: ["ROLE_IMPORTACAO_RADAR_APP"],
        to: "importacaoapp",
      },

      {
        icon: "mdi-cash-clock",
        title: "Concilia??o",
        roles: ["ROLE_CONCILIACAO"],
        to: "conciliacao",
      },

      {
        icon: "mdi-text-box-search-outline",
        title: "Documentos",
        roles: ["ROLE_DOCUEMNTOS_IVERTEX"],
        to: "documentos",
      },
      {
        title: "",
      },

      {
        title: "Administrador",
        roles: [
          "ROLE_NOTIFICACAO",
          "ROLE_LOG",
          "ROLE_USER",
          "ROLE_COLABORADORES",
        ],
      },

      {
        icon: "mdi-account-multiple",
        title: "Colaboradores",
        roles: ["ROLE_COLABORADORES"],
        to: "colaboradores",
      },
      {
        icon: "mdi-bell",
        title: "Notifica??o",
        roles: ["ROLE_NOTIFICACAO"],
        to: "notificacao",
      },

      {
        icon: "mdi-history",
        title: "LOG",
        roles: ["ROLE_LOG"],
        to: "historico",
      },

      {
        icon: "mdi-account",
        title: "Usu?rio",
        roles: ["ROLE_USER"],
        to: "usuario",
      },

      {
        title: "",
      },

      {
        title: "Configura??es",
      },

      {
        icon: "mdi-key",
        title: "Alterar Senha",
        to: "register",
      },

      {
        icon: "mdi-logout",
        title: "Sair",
        to: "login",
      },
    ], */
  }),

  computed: {
    ...mapState(["barColor", "barImage"]),
    drawer: {
      get() {
        //  return true;
        //alert('.....'+this.$store.state.drawer)
        return this.$store.state.drawer;
      },
      set(val) {
        //alert(val)
        this.$store.commit("SET_DRAWER", val);
      },
    },

    descobrirUser() {
      this.user = JSON.parse(sessionStorage.getItem("user"));
    },

    selectedModule() {
      return this.$store.state.selectedModule;
    },

    selectedModuleName() {
      return this.selectedModule?.name || "Módulo";
    },

    currentModuleIcon() {
      return this.selectedModule?.icon || "mdi-folder";
    },

    moduleColor() {
      return this.selectedModule?.color || "rgb(71 130 180)";
    },

    computedItems() {
      // Se nenhum m?dulo estiver selecionado, n?o mostra nada no menu
      const selectedModule = this.$store.state.selectedModule;

      if (!selectedModule) {
        return [];
      }

      let mappedItems = this.items.map(this.mapItem).filter(Boolean);

      if (selectedModule.groups) {
        mappedItems = this.filterByModule(mappedItems, selectedModule.groups);
      }

      // Remove dividers do in?cio
      while (mappedItems.length && mappedItems[0].title === "") {
        mappedItems.shift();
      }

      // Remove dividers do fim
      while (
        mappedItems.length &&
        mappedItems[mappedItems.length - 1].title === ""
      ) {
        mappedItems.pop();
      }

      // Remove dividers duplicados no meio
      const result = [];
      let lastWasDivider = false;

      for (const item of mappedItems) {
        const isDivider = item.title === "";

        if (isDivider && lastWasDivider) continue;

        result.push(item);
        lastWasDivider = isDivider;
      }

      return result;
    },

    isMobile() {
      return this.$vuetify.breakpoint.width < 1024;
    },

    miniVariant() {
      return this.collapsed && !this.isMobile;
    },

    secoes() {
      const secoes = [];
      for (const item of this.computedItems) {
        if (item.title === "") continue;
        if (!item.to && !item.icon && !item.children) {
          secoes.push({ label: item.title, items: [] });
        } else if (item.to && secoes.length) {
          secoes[secoes.length - 1].items.push(item);
        }
      }
      return secoes.filter((secao) => secao.items.length);
    },

    profile() {
      return {
        avatar: true,
        title: this.$t("avatar"),
      };
    },
  },

  methods: {
    mapItem(item) {
      if (this.user == "") {
        this.user = JSON.parse(sessionStorage.getItem("user"));
      }

      const hasPermission = this.checkPermission(item);

      let modifiedItem = { ...item };

      // Lista de rotas que voc? quer garantir que sejam absolutas
      const rotasAbsolutas = ["cobranca", "negativados", "remessa", "relatoriosSeguro", "configRelatoriosSeguro"];
      if (
        modifiedItem.to &&
        typeof modifiedItem.to === "string" &&
        !rotasAbsolutas.includes(modifiedItem.to.replace(/^\/+/, "")) // s? corrige se N?O estiver na lista
      ) {
        // Corrige para sempre uma ?nica barra
        modifiedItem.to = "/" + modifiedItem.to.replace(/^\/+/, "");
      }

      return hasPermission
        ? {
            ...modifiedItem,
            children: modifiedItem.children
              ? modifiedItem.children.map(this.mapItem)
              : undefined,
            title: this.$t(modifiedItem.title),
          }
        : null;
    },

    checkPermission(item) {
      if (!item.roles || item.roles.length === 0) return true;

      const userRoles = Array.isArray(this.user?.roles) ? this.user.roles : [];

      return (
        userRoles.includes("ROLE_ADMIN") ||
        item.roles.some((role) => userRoles.includes(role))
      );
    },

    ranking() {},

    alternarColapso() {
      this.collapsed = !this.collapsed;
      localStorage.setItem(COLLAPSED_KEY, this.collapsed ? "1" : "0");
    },

    isActive(item) {
      const path = this.$route.path;
      return path === item.to || path.startsWith(`${item.to}/`);
    },

    logout() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },

    filterByModule(items, allowedGroups) {
      const result = [];
      const fixedGroups = [];
      let currentGroupItem = null;
      let groupItems = [];

      // Grupos que sempre devem aparecer no final
      const alwaysShowGroups = [];

      const pushGroup = (target, groupItem, itemsOfGroup) => {
        target.push({
          title: groupItem.title,
          isBeta: groupItem.isBeta,
          roles: groupItem.roles,
        });
        target.push(...itemsOfGroup);
      };

      for (const item of items) {
        // Se é um divisor vazio, fecha o grupo atual para não vazar itens entre seções
        if (item.title === "") {
          if (currentGroupItem) {
            const currentGroup = currentGroupItem.title;
            const isFixed = alwaysShowGroups.includes(currentGroup);
            const isAllowed = allowedGroups.includes(currentGroup);

            if (isFixed) {
              pushGroup(fixedGroups, currentGroupItem, groupItems);
            } else if (isAllowed) {
              const hasMenuItems = groupItems.some((groupItem) => groupItem.to);
              if (hasMenuItems) {
                pushGroup(result, currentGroupItem, groupItems);
              }
            }
            currentGroupItem = null;
            groupItems = [];
          }
          continue;
        }

        // Se é um título de grupo (sem ícone e sem rota)
        if (item.title && !item.to && !item.icon) {
          // Se temos um grupo anterior, processa ele
          if (currentGroupItem) {
            const currentGroup = currentGroupItem.title;
            const isFixed = alwaysShowGroups.includes(currentGroup);
            const isAllowed = allowedGroups.includes(currentGroup);

            if (isFixed) {
              pushGroup(fixedGroups, currentGroupItem, groupItems);
            } else if (isAllowed) {
              const hasMenuItems = groupItems.some((groupItem) => groupItem.to || (groupItem.children && groupItem.children.length > 0));
              if (hasMenuItems) {
                pushGroup(result, currentGroupItem, groupItems);
              }
            }
          }

          // Inicia novo grupo
          currentGroupItem = item;
          groupItems = [];
        } else if (currentGroupItem) {
          // Adiciona item ao grupo atual
          groupItems.push(item);
        }
      }

      // Processa último grupo
      if (currentGroupItem) {
        const currentGroup = currentGroupItem.title;
        const isFixed = alwaysShowGroups.includes(currentGroup);
        const isAllowed = allowedGroups.includes(currentGroup);

        if (isFixed) {
          pushGroup(fixedGroups, currentGroupItem, groupItems);
        } else if (isAllowed) {
          const hasMenuItems = groupItems.some((groupItem) => groupItem.to || (groupItem.children && groupItem.children.length > 0));
          if (hasMenuItems) {
            pushGroup(result, currentGroupItem, groupItems);
          }
        }
      }

      // Adiciona grupos fixos no final
      return [...result, ...fixedGroups];
    },
  },
};
</script>

<style scoped>
#core-navigation-drawer {
  background-color: var(--app-sidebar-bg) !important;
  color: var(--app-sidebar-fg);
}

.pulse-sidebar {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.pulse-sidebar__brand {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 64px;
  flex-shrink: 0;
  padding: 0 16px;
  cursor: pointer;
}

.pulse-sidebar__logo {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  object-fit: contain;
}

.pulse-sidebar__name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.875rem;
  font-weight: 600;
  color: #fff;
}

.pulse-sidebar__separator {
  height: 1px;
  margin: 0 12px 8px;
  background: rgba(255, 255, 255, 0.1);
}

.pulse-sidebar__nav {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 12px 16px;
}

.pulse-sidebar__section + .pulse-sidebar__section {
  margin-top: 20px;
}

.pulse-sidebar__section-label {
  margin: 0 0 4px;
  padding: 0 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
}

.pulse-sidebar__link {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 2px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 0.875rem;
  color: #cbd5e1 !important;
  text-decoration: none;
  transition: background-color 0.15s, color 0.15s;
}

.pulse-sidebar__link:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff !important;
}

.pulse-sidebar__link--active,
.pulse-sidebar__link--active:hover {
  background: var(--app-accent);
  color: #fff !important;
}

.pulse-sidebar__home {
  margin: 0 12px 8px;
}

.pulse-sidebar__icon {
  flex-shrink: 0;
  font-size: 15px;
}

.pulse-sidebar__label {
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.pulse-sidebar__beta {
  padding: 1px 6px;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.05em;
  color: #fff;
  background: rgba(168, 85, 247, 0.6);
}

.pulse-sidebar__collapse {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  padding: 12px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.875rem;
  color: #94a3b8;
  background: transparent;
  cursor: pointer;
  transition: color 0.15s;
}

.pulse-sidebar__collapse:hover {
  color: #fff;
}
</style>
